import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const GramniddhiDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { grampanchayatName, categoryLabel, arthikVarshLabel } = location.state || {};

  const [activeTab, setActiveTab] = useState('kayam');

  const handleBack = () => {
    navigate('/');
  };

  const handleMilakhatClick = () => {
    navigate('/milakhatnondani');
  };

  const [formData, setFormData] = useState({
    date: '',
    description: '',
    amount: '',
    type: 'income'
  });

  const [incomeList, setIncomeList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [showRegistrationForm, setShowRegistrationForm] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newEntry = {
      id: Date.now(),
      date: formData.date,
      description: formData.description,
      amount: formData.amount,
      type: formData.type === 'income' ? 'जमा' : 'नावे'
    };

    if (formData.type === 'income') {
      setIncomeList(prev => [...prev, newEntry]);
    } else {
      setExpenseList(prev => [...prev, newEntry]);
    }

    // Reset form
    setFormData({
      date: '',
      description: '',
      amount: '',
      type: 'income'
    });
  };

  const vehavar = [
    { id: 1, date: '०१/०४/२०२३', description: 'ग्रामनिधी खाते उद्घाटन', amount: '१,००,०००', type: 'जमा' },
    { id: 2, date: '१५/०५/२०२३', description: 'शासकीय अनुदान', amount: '५,००,०००', type: 'जमा' },
    { id: 3, date: '२०/०६/२०२३', description: 'विकास कामांसाठी', amount: '२,५०,०००', type: 'नावे' },
    { id: 4, date: '१०/०७/२०२३', description: 'पाणीपुरवठा योजना', amount: '१,५०,०००', type: 'नावे' },
    { id: 5, date: '०५/०८/२०२३', description: 'स्थानिक योगदान', amount: '३,००,०००', type: 'जमा' },
  ];

  const reports = [
    { id: 1, name: 'मासिक अहवाल - एप्रिल २०२३', date: '३०/०४/२०२३', type: 'पीडीएफ' },
    { id: 2, name: 'मासिक अहवाल - मे २०२३', date: '३१/०५/२०२३', type: 'पीडीएफ' },
    { id: 3, name: 'त्रैमासिक अहवाल - Q1 २०२३', date: '३०/०६/२०२३', type: 'पीडीएफ' },
    { id: 4, name: 'अर्धवार्षिक अहवाल - २०२३', date: '३०/०९/२०२३', type: 'पीडीएफ' },
  ];

  const arthikReports = [
    { id: 1, title: 'एकूण जमा रक्कम', amount: '९,००,०००', period: '०१/०४/२०२३ ते ३१/१२/२०२३' },
    { id: 2, title: 'एकूण खर्च रक्कम', amount: '४,००,०००', period: '०१/०४/२०२३ ते ३१/१२/२०२३' },
    { id: 3, title: 'उर्वरित रक्कम', amount: '५,००,०००', period: '३१/१२/२०२३ पर्यंत' },
    { id: 4, title: 'व्याज उत्पन्न', amount: '२५,०००', period: 'वार्षिक' },
    { id: 5, title: 'अपेक्षित वार्षिक व्याज', amount: '४०,०००', period: '२०२३-२४' },
  ];

  const tabs = [
    { id: 'kayam', label: 'कायम माहिती', icon: '📋' },
    { id: 'vehavar', label: 'व्यवहार', icon: '📊' },
    { id: 'report', label: 'रिपोर्ट', icon: '📄' },
    { id: 'arthik', label: 'आर्थिक रिपोर्ट', icon: '💰' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-cyan-50 to-blue-50 p-4 md:p-8">
      {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-20 -left-20 w-96 h-96 bg-gradient-to-r from-emerald-200 to-teal-200 rounded-full mix-blend-multiply opacity-20 animate-float"></div>
        <div className="absolute top-1/2 -right-20 w-96 h-96 bg-gradient-to-r from-cyan-200 to-blue-200 rounded-full mix-blend-multiply opacity-20 animate-float animation-delay-2000"></div>
        <div className="absolute -bottom-20 left-1/3 w-96 h-96 bg-gradient-to-r from-green-200 to-emerald-200 rounded-full mix-blend-multiply opacity-20 animate-float animation-delay-4000"></div>
      </div>

      {/* Main Container */}
      <div className="relative z-10 max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={handleBack}
            className="flex items-center space-x-2 text-emerald-600 hover:text-emerald-700 font-medium transition-colors duration-200 mb-4"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            <span>मुख्य पृष्ठावर परत जा</span>
          </button>

          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-4">
              ग्रामनिधी माहिती
            </h1>
            <div className="inline-block px-6 py-3 bg-gradient-to-r from-emerald-100 to-teal-100 rounded-full border border-emerald-200">
              <p className="text-lg font-medium text-emerald-700">
                {grampanchayatName} - {arthikVarshLabel}
              </p>
            </div>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="mb-8">
          <div className="flex flex-wrap justify-center gap-2 p-2 bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/40">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
                  activeTab === tab.id
                    ? 'bg-gradient-to-r from-emerald-500 to-teal-500 text-white shadow-lg transform scale-105'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-800'
                }`}
              >
                <span className="text-xl">{tab.icon}</span>
                <span>{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Content Area */}
        <div className="backdrop-blur-xl bg-white/95 rounded-3xl shadow-2xl border border-white/40 overflow-hidden">
          {/* कायम माहिती Section */}
          {activeTab === 'kayam' && (
            <div className="p-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center space-x-3">
                <span className="text-3xl">📋</span>
                <span>कायम माहिती</span>
              </h2>
              
              {/* Basic Info Cards */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl p-4 border border-emerald-200">
                  <h3 className="text-sm font-semibold text-emerald-600 uppercase tracking-wider mb-2">
                    ग्रामपंचायत नाव
                  </h3>
                  <p className="text-lg font-medium text-gray-800">{grampanchayatName || '-'}</p>
                </div>
                <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl p-4 border border-emerald-200">
                  <h3 className="text-sm font-semibold text-emerald-600 uppercase tracking-wider mb-2">
                    विभाग
                  </h3>
                  <p className="text-lg font-medium text-gray-800">{categoryLabel || '-'}</p>
                </div>
                <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl p-4 border border-emerald-200">
                  <h3 className="text-sm font-semibold text-emerald-600 uppercase tracking-wider mb-2">
                    आर्थिक वर्ष
                  </h3>
                  <p className="text-lg font-medium text-gray-800">{arthikVarshLabel || '-'}</p>
                </div>
              </div>

              {/* मिळकत नोंदणी बटण */}
              <div className="flex justify-center">
                <button
                  onClick={handleMilakhatClick}
                  className="px-8 py-4 bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-bold rounded-xl shadow-lg hover:shadow-xl hover:from-blue-600 hover:to-indigo-600 transform hover:-translate-y-1 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-blue-300 flex items-center space-x-3"
                >
                  <span className="text-2xl">💰</span>
                  <span className="text-lg">मिळकत नोंदणी</span>
                </button>
              </div>
            </div>
          )}

          {/* वेहवार Section */}
          {activeTab === 'vehavar' && (
            <div className="p-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center space-x-3">
                <span className="text-3xl">📊</span>
                <span>वेहवार</span>
              </h2>
              <div className="overflow-x-auto">
                <table className="w-full bg-white rounded-xl overflow-hidden shadow-lg">
                  <thead className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white">
                    <tr>
                      <th className="px-6 py-4 text-left">तारीख</th>
                      <th className="px-6 py-4 text-left">वर्णन</th>
                      <th className="px-6 py-4 text-right">रक्कम</th>
                      <th className="px-6 py-4 text-center">प्रकार</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vehavar.map((item, index) => (
                      <tr key={item.id} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                        <td className="px-6 py-4 text-gray-700">{item.date}</td>
                        <td className="px-6 py-4 text-gray-700">{item.description}</td>
                        <td className="px-6 py-4 text-right font-medium text-gray-800">₹{item.amount}</td>
                        <td className="px-6 py-4 text-center">
                          <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                            item.type === 'जमा' 
                              ? 'bg-green-100 text-green-700' 
                              : 'bg-red-100 text-red-700'
                          }`}>
                            {item.type}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* रिपोर्ट Section */}
          {activeTab === 'report' && (
            <div className="p-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center space-x-3">
                <span className="text-3xl">📄</span>
                <span>रिपोर्ट</span>
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {reports.map((report) => (
                  <div key={report.id} className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-200 hover:shadow-lg transition-shadow duration-300">
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">{report.name}</h3>
                        <p className="text-sm text-gray-600 mb-3">तारीख: {report.date}</p>
                        <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm font-medium">
                          {report.type}
                        </span>
                      </div>
                      <button className="ml-4 p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* आर्थिक रिपोर्ट Section */}
          {activeTab === 'arthik' && (
            <div className="p-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center space-x-3">
                <span className="text-3xl">💰</span>
                <span>आर्थिक रिपोर्ट</span>
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {arthikReports.map((report) => (
                  <div key={report.id} className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border border-amber-200 hover:shadow-lg transition-shadow duration-300">
                    <h3 className="text-lg font-semibold text-gray-800 mb-3">{report.title}</h3>
                    <p className="text-2xl font-bold text-amber-600 mb-2">₹{report.amount}</p>
                    <p className="text-sm text-gray-600">{report.period}</p>
                  </div>
                ))}
              </div>
              
              {/* Summary Card */}
              <div className="mt-8 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-xl p-6 text-white">
                <h3 className="text-xl font-bold mb-4">आर्थिक सारांश</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="text-center">
                    <p className="text-emerald-100 text-sm mb-1">एकूण जमा</p>
                    <p className="text-2xl font-bold">₹९,००,०००</p>
                  </div>
                  <div className="text-center">
                    <p className="text-emerald-100 text-sm mb-1">एकूण खर्च</p>
                    <p className="text-2xl font-bold">₹४,००,०००</p>
                  </div>
                  <div className="text-center">
                    <p className="text-emerald-100 text-sm mb-1">उर्वरित रक्कम</p>
                    <p className="text-2xl font-bold">₹५,००,०००</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Add custom animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }
          33% {
            transform: translateY(-20px) rotate(120deg);
          }
          66% {
            transform: translateY(20px) rotate(240deg);
          }
        }
        
        .animate-float {
          animation: float 20s infinite ease-in-out;
        }
        
        .animation-delay-2000 {
          animation-delay: 7s;
        }
        
        .animation-delay-4000 {
          animation-delay: 14s;
        }
      `}</style>
    </div>
  );
};

export default GramniddhiDetails;
